<template>
    <div>
        <div id="title">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h3 class="border-bottom" style="padding-top: 15px">
                            <div style="display: inline-block;">
                                <span style="text-transform: uppercase">Интеллектуальный заказ</span><br/>
                                <span style="text-align: center; font-size: 16px;">Рассчет комплекта для "{{set.hh}} {{set.hh_add}}" - {{group.name}}</span>
                                <span style="font-size: 17px; display: block; margin-top: 2px;">
                                    <b style="font-weight: 600;">Добавлено наименований:</b> {{addedCounter}}
                                    <b style="font-weight: 600;">/ Выбрано: </b>
                                    <span v-bind:class="{green: group.restAmount == 0}" style="font-weight: 600;">{{group.actualAmount}}</span>
                                    <span> из </span>
                                    <span v-bind:class="{red: group.restAmount > 0}">{{group.amountAct}}</span>
                                    <b style="font-weight: 600;"> / Осталось: </b>
                                    <span class="left">{{group.restAmount}}</span>
                                </span>
                            </div>
                            <a href="/configurator" class="btn btn-outline-primary itemsListBack"><i class="las la-angle-left"></i> Вернуться</a>

                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <main role="main" class="container" style="margin-top: 0px !important;">
            <div class="row">
                <div class="col-md-12 preview">
                    <div class="row">
                        <div class="col-md-4">
                            <input class="form-control search" v-model="search" @change="saveFilterData()" placeholder="Поиск по наименованию" />
                        </div>
                        <div class="col-md-4">
                            <a href="#" class="filterButton" v-if="[9467, 8460, 30004973, 30004746, 8436].indexOf(parseInt(groupId)) != -1" @click="filterOpened = !filterOpened">Фильтр <i v-if="filterOpened" class="las la-angle-up"></i><i v-else class="las la-angle-down"></i></a>
                        </div>
                    </div>
                    <div class="row filter" v-if="[9467, 8460, 30004973, 30004746, 8436].indexOf(parseInt(groupId)) != -1" v-bind:class="{hidden: !filterOpened}">
                        <div class="filter-checkboxes" v-if="groupId != 30004746" v-bind:class="{'col-lg-3': groupId == 9467, 'col-lg-4': [8460, 30004973, 30004746, 8436].indexOf(parseInt(groupId)) != -1}">
                            <p class="filter-title">Цвет материала</p>
                            <div class="button" @click="colorsFilterOpened = !colorsFilterOpened">
                                <div class="text" v-if="filterData.colors.length > 0">Цвет ({{filterData.colors.length}})</div>
                                <div class="text" v-else>Выбрать цвет</div>
                            </div>
                            <div v-if="colorsFilterOpened" class="overlay" @click="colorsFilterOpened = !colorsFilterOpened"></div>
                            <div class="colorsFilter" v-bind:class="{hidden: !colorsFilterOpened}">
                                <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                    <div v-if="filtersAvailable.colors.indexOf(1) != -1" >
                                        <input id="red1" type="checkbox" value="1" class="red" @click="toggleFilterData('colors', 1)">
                                        <label for="red1" title="Красный">Красный</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(2) != -1">
                                        <input id="orange2" type="checkbox" value="2" class="orange" @click="toggleFilterData('colors', 2)">
                                        <label for="orange2" title="Оранжевый">Оранжевый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(3) != -1">
                                        <input id="yellow3" type="checkbox" value="3" class="yellow" @click="toggleFilterData('colors', 3)">
                                        <label for="yellow3" title="Желтый">Желтый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(4) != -1">
                                        <input id="green4" type="checkbox" value="4" class="green" @click="toggleFilterData('colors', 4)">
                                        <label for="green4" title="Зеленый">Зеленый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(5) != -1">
                                        <input id="blue5" type="checkbox" value="5" class="blue" @click="toggleFilterData('colors', 5)">
                                        <label for="blue5" title="Синий">Синий</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(6) != -1">
                                        <input id="purple6" type="checkbox" value="6" class="purple" @click="toggleFilterData('colors', 6)">
                                        <label for="purple6" title="Розовый">Розовый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(7) != -1">
                                        <input id="black7" type="checkbox" value="7" class="black" @click="toggleFilterData('colors', 7)">
                                        <label for="black7" title="Черный">Черный</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(8) != -1">
                                        <input id="white8" type="checkbox" value="8" class="white" @click="toggleFilterData('colors', 8)">
                                        <label for="white8" title="Белый">Белый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(9) != -1">
                                        <input id="beige9" type="checkbox" value="9" class="beige" @click="toggleFilterData('colors', 9)">
                                        <label for="beige9" title="Бежевый">Бежевый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(10) != -1">
                                        <input id="gray10" type="checkbox" value="10" class="gray" @click="toggleFilterData('colors', 10)">
                                        <label for="gray10" title="Серый">Серый</label>
                                    </div>
                                    <div v-if="filtersAvailable.colors.indexOf(11) != -1">
                                        <input id="brown11" type="checkbox" value="11" class="brown" @click="toggleFilterData('colors', 11)">
                                        <label for="brown11" title="Коричневый">Коричневый</label>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="col-lg-3 filter-checkboxes light" v-if="groupId == 9467">
                            <p class="filter-title">Тип</p>
                            <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                <div v-if="filtersAvailable.types.indexOf(1) != -1">
                                    <input id="rolo" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('types', 1)">
                                    <label for="rolo">Ткани для рулонных штор</label>
                                </div>
                                <div v-if="filtersAvailable.types.indexOf(2) != -1">
                                    <input id="zebra" type="checkbox" value="1" class="light_gray" @click="toggleFilterData('types', 2)">
                                    <label for="zebra">Ткани для рулонных штор DUO (зебра)</label>
                                </div>
                            </fieldset>
                        </div>
                        <div class="filter-checkboxes light" v-if="groupId != 8436 && groupId != 30004746" v-bind:class="{'col-lg-3': groupId == 9467, 'col-lg-4': [8460, 30004973, 30004746].indexOf(parseInt(groupId)) != -1}">
                            <p class="filter-title">Светопроницаемость</p>
                            <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                <div v-if="filtersAvailable.blackouts.indexOf(0) != -1 && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                    <input id="blackout0" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('blackouts', 0)">
                                    <label for="blackout0">70%</label>
                                </div>
                                <!--                                    <div>-->
                                <!--                                        <input id="blackout1" type="checkbox" value="1" class="beige" @click="toggleFilterData('blackouts', 1)">-->
                                <!--                                        <label for="blackout1">70%</label>-->
                                <!--                                    </div>-->
<!--                                <div v-if="filtersAvailable.blackouts.indexOf(2) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">-->
<!--                                    <input id="blackout2" type="checkbox" value="2" class="light_gray" @click="toggleFilterData('blackouts', 2)">-->
<!--                                    <label for="blackout2">50%</label>-->
<!--                                </div>-->
                                <div v-if="filtersAvailable.blackouts.indexOf(3) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                    <input id="blackout3" type="checkbox" value="3" class="light_gray" @click="toggleFilterData('blackouts', 3)">
                                    <label for="blackout3">50%</label>
                                </div>
                                <div v-if="filtersAvailable.blackouts.indexOf(4) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                    <input id="blackout4" type="checkbox" value="4" class="light_gray" @click="toggleFilterData('blackouts', 4)">
                                    <label for="blackout4">20%</label>
                                </div>
                                <div v-if="filtersAvailable.blackouts.indexOf(5) != -1">
                                    <input id="blackout5" type="checkbox" value="5" class="light_gray" @click="toggleFilterData('blackouts', 5)">
                                    <label for="blackout5">Blackout</label>
                                </div>
                            </fieldset>
                        </div>
                        <div class="filter-checkboxes price" v-bind:class="{'col-lg-3': groupId == 9467, 'col-lg-4': [8460, 30004973, 30004746, 8436].indexOf(parseInt(groupId)) != -1}">
                            <p class="filter-title">Ценовая категория</p>
                            <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                <div v-if="filtersAvailable.prices.indexOf(0) != -1">
                                    <input id="price0" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('prices', 0)">
                                    <label for="price0">0</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(1) != -1">
                                    <input id="price1" type="checkbox" value="1" class="light_gray" @click="toggleFilterData('prices', 1)">
                                    <label for="price1">1</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(2) != -1">
                                    <input id="price2" type="checkbox" value="2" class="light_gray" @click="toggleFilterData('prices', 2)">
                                    <label for="price2">2</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(3) != -1">
                                    <input id="price3" type="checkbox" value="3" class="light_gray" @click="toggleFilterData('prices', 3)">
                                    <label for="price3">3</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(4) != -1">
                                    <input id="price4" type="checkbox" value="4" class="light_gray" @click="toggleFilterData('prices', 4)">
                                    <label for="price4">4</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(5) != -1">
                                    <input id="price5" type="checkbox" value="5" class="light_gray" @click="toggleFilterData('prices', 5)">
                                    <label for="price5">5</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(6) != -1">
                                    <input id="price6" type="checkbox" value="6" class="light_gray" @click="toggleFilterData('prices', 6)">
                                    <label for="price6">6</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(7) != -1">
                                    <input id="price7" type="checkbox" value="7" class="light_gray" @click="toggleFilterData('prices', 7)">
                                    <label for="price7">7</label>
                                </div>
                                <div v-if="filtersAvailable.prices.indexOf(8) != -1">
                                    <input id="price8" type="checkbox" value="8" class="light_gray" @click="toggleFilterData('prices', 8)">
                                    <label for="price8">8</label>
                                </div>
                            </fieldset>
                            <p>Найдено материалов: {{filteredList.length}}</p>
                        </div>
                    </div>

                    <div v-if="loading" class="loader">
                        <img src="../assets/img/loader.gif" alt="Загрузка" />
                        <p>Загрузка</p>
                    </div>
                    <table class="table itemsList" v-else-if="filteredList.length > 0">
                        <thead>
                            <tr>
                                <td width="61px">Фото <br><i class="las la-angle-down"></i></td>
                                <td min-width="48px">Наименование товара <br><i class="las la-angle-down"></i></td>
                                <td width="60px">Min заказ <br><i class="las la-angle-down"></i></td>
                                <td>Кол-во <br><i class="las la-angle-down"></i></td>
                                <td>Сумма по прайсу <br><i class="las la-angle-down"></i></td>
                                <td>Сумма со скидкой <br><i class="las la-angle-down"></i></td>
                                <td>Добавить<br/> к заказу <br><i class="las la-angle-down"></i></td>
                            </tr>
                        </thead>
                        <tbody v-for="item in filteredList" v-bind:key="item.id">
                            <!--<tr v-if="(item.enableStock || item.enableStock2 || item.enableStock3 || item.has_priv)" class="item" :class="{'absent': (!item.enableStock && !item.enableStock2 && !item.enableStock3)}">-->
                            <tr class="item" :class="{'absent': (!item.enableStock && !item.enableStock2 && !item.enableStock3)}" :bgcolor="item.stockColor">
                                <td data-label="Фото" class="noAfter">
                                    <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + item.img +'.png'" :autoplay="true" :description="item.name">-->
                                        <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + item.img + '.png'"-->
                                             <!--:alt="item.name" />-->
                                    <!--</silentbox-single>-->
                                    <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + item.img + '.png'" :autoplay="true" :description="item.name">
                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.img + '.png'"
                                             :alt="item.name" />
                                    </silentbox-single>
                                </td>
                                <td data-label="Наименование товара">
                                    <span v-bind:class="{'nameSpan': item.qualityFlag}">{{item.name}}</span>
                                    <!--<div v-if="item.qualityFlag" class="thumb" v-tooltip.right="{content: linkContent + item.qualityFlagText, trigger: 'click'}"><i class="las la-thumbs-up"></i></div>-->
                                    <div class="thumb">
                                        <v-popover placement="right" :show="item.id == activeThumbID" v-if="item.qualityFlag">
                                            <div @click="setActiveThumb(item)">
<!--                                                <i class="las la-thumbs-up tooltip-target"></i>-->
                                                <img src="./../assets/img/thumb.png" style="width: 34px;" alt="" class="tooltip-target" />
                                            </div>

                                            <template slot="popover">
                                                <i @click="closeFlag()" v-close-popover class="closeButton las la-times-circle"></i>
                                                <div v-html="linkContent + item.qualityFlagText"></div>
                                                <div v-if="item.videoLink && item.videoLink.length > 10">
                                                    <button class="btn btn-outline-primary" @click="openVideo(item.videoLink)"><i class="las la-video"></i> Видео</button>
                                                </div>
                                            </template>
                                        </v-popover>
                                    </div>
                                </td>
                                <!--<td data-label="Наименование товара">-->
                                    <!--{{item.name}}-->
                                <!--</td>-->
                                <td data-label="Min заказ" v-bind:class="{'noAfter': (item.enableStock || item.enableStock2 || item.enableStock3)}">{{item.package}}{{item.measure}}</td>
                                <!--<td data-label="Кол-во" v-bind:class="{'noAfter': (item.enableStock || item.enableStock2 || item.enableStock3)}">-->
                                <td data-label="Кол-во" class="noAfter">
                                    <div class="input-group" v-if="(item.enableStock || item.enableStock2 || item.enableStock3) && boxAction.indexOf(item.id) == -1">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-left-minus" @click="itemMinus(item.id, 0)">
                                                <i class="la la-minus"></i>
                                            </button>
                                        </span>
                                        <input v-if="item.allowEdit" type="number" min="0" name="quantity" class="form-control input-number" v-model="item.count" @input="updateCount(item.id, 0, false)" @change="updateCount(item.id, 0, true)">
                                        <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="item.count">
                                        <span class="input-group-prepend">
                                            <button class="btn quantity-right-plus" @click="itemPlus(item.id, 0)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: item.clicked && (item.count + item.package) > item.gdsInStock}">
                                                <i class="la la-plus"></i>
                                            </button>
                                        </span>
                                    </div>
                                    <div v-else-if="(item.enableStock || item.enableStock2 || item.enableStock3) && boxAction.indexOf(item.id) != -1" class="boxAction" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: item.clicked && (((item.count + item.package) > item.gdsInStock) || (item.count + 800) > item.gdsInStock)}">
                                        <span v-tooltip.top="{content: 'Если нужен метраж меньше 400 м.п., закажите готовые ламели по выгодной цене, подробности уточняйте у ведущего менеджера.', trigger: 'manual', show: item.clicked2 && item.count == item.package}">Выбрано: {{item.count}}</span>
                                        <div class="countField" v-bind:class="{ notSelected: item.box }">
                                            <span>кратно min<br/>заказу</span>
                                            <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" @click="itemMinus(item.id, 0)">
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                                <input v-if="item.allowEdit" type="number" min="0" name="quantity" class="form-control input-number" v-model="item.count1" @input="updateCount(item.id, 0, false)" @change="updateCount(item.id, 0, true)" @click="changeInput(item, 1)">
                                                <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="item.count1">
                                                <span class="input-group-prepend">
                                                    <button class="btn quantity-right-plus" @click="itemPlus(item.id, 0)" >
                                                        <i class="la la-plus"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="countField" v-bind:class="{ notSelected: !item.box }">
                                            <span>кратно<br/>коробке</span>
                                            <div class="boxSale">-3%</div>
                                            <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" @click="itemMinusBox(item.id, 0)">
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                                <input v-if="item.allowEdit" type="number" min="0" name="quantity" class="form-control input-number" v-model="item.count2" @input="updateCountBox(item.id, 0, false)" @change="updateCountBox(item.id, 0, true)" @click="changeInput(item, 2)">
                                                <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="item.count2">
                                                <span class="input-group-prepend">
                                                    <button class="btn quantity-right-plus" @click="itemPlusBox(item.id, 0)" >
                                                        <i class="la la-plus"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="item.prihod == ''">
                                        {{item.stockAlt}}
                                    </div>
                                    <div v-else>
                                        {{item.prihod}}
                                    </div>
                                </td>
                                <td data-label="Сумма по прайсу" v-if="(item.enableStock || item.enableStock2 || item.enableStock3)" class="sum">
                                    <div>
                                        <span class="allSum">{{item.sum | fixed}} руб.</span>
                                        <span class="pricePerOne">{{item.priceRub | fixed}} руб./{{item.measure}}</span>
                                    </div>
                                </td>
                                <td v-else class="empty noAfter" colspan="2">
                                    <button v-if="!item.notify" class="btn btn-outline-primary" style="float: right" @click="notifyMe(item)"><i class="las la-bell"></i> Уведомить о поступлении</button>
                                    <button v-if="item.notify" class="btn btn-outline-primary" style="float: right" @click="disableNotifications(item)"><i class="las la-bell-slash"></i> Не уведомлять</button>
                                </td>
                                <td data-label="Сумма со скидкой" class="saleSum noAfter" v-if="(item.enableStock || item.enableStock2 || item.enableStock3)">
                                    <div class="totalSale" v-if="action4.indexOf(item.id) == -1">
                                        -<span v-if="item.boxAction">{{item.real_sale + 3}}</span><span v-else>{{item.real_sale}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.real_sale}}+3)</span>
                                    </div>
                                    <div v-else class="totalSale"><br/></div>
                                    <div >
                                        <span class="allSaleSum">{{item.sale_sum | fixed}} руб.</span>
                                        <span class="pricePerOne">{{item.priceRubSale | fixed}} руб./{{item.measure}}</span>
                                    </div>
                                    <!--<img v-if="item.discount_pics_ids.indexOf(item.id) !== -1 && set.id_good == '20000221'" class="mt-1" src="./../assets/img/actionGet2.png" />-->
                                    <!--<img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                    <img v-if="item.discount_pics_ids.indexOf(item.id) !== -1 && action2.indexOf(item.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                    <img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1 && action3.indexOf(item.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                    <img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                </td>
                                <!--<td v-else class="empty"></td>-->
                                <td v-if="(item.enableStock || item.enableStock2 || item.enableStock3)">
                                    <button v-if="!item.selected" class="btn btn-primary" @click="add(item.id, 0)" type="button">
                                        Добавить
                                    </button>
                                    <button v-if="item.selected" class="btn btn-secondary" @click="add(item.id, 0)" type="button">
                                        Добавлено
                                    </button>
                                </td>
                                <td v-else-if="item.has_priv && groupId != 10113">
                                    <!--<button v-if="item.privileges.length > 0" class="btn btn-secondary btn-privilege" v-bind:class="{active: item.privilegesExpanded}" @click="expandPrivileges(item.id)"><i class="las la-crown"></i> Привилегия</button>-->
                                    <button class="btn btn-secondary btn-privilege" v-bind:class="{active: item.privilegesExpanded}" @click="expandPrivileges(item.id)"><i class="las la-crown"></i> Привилегия</button>
                                </td>
                                <td v-else-if="[8436, 8460, 9467, 30004973].indexOf(group.id) != -1 && item.analogs">
                                    <button v-if="!item.analogsExpanded" style="width: 114px;" class="btn btn-outline-primary" @click="expandAnalogs(item.id)"><i class="las la-angle-down"></i> Аналоги</button>
                                    <button v-else class="btn btn-outline-primary" style="width: 114px;" @click="expandAnalogs(item.id)"><i class="las la-angle-up"></i> Аналоги</button>
                                </td>
                                <td v-else class="empty"></td>
                            </tr>
                            <tr v-if="item.privilegesExpanded" class="privilege">
                                <td colspan="7" class="noAfter">
                                    <h3 style="padding: 5px;">Привилегия</h3>
                                    <table class="table itemsList" style="border: 1px solid #dee2e6; box-shadow: 2px 3px 6px 0px #b9b9b9;">
                                        <tbody v-for="privilege in item.privileges" v-bind:key="privilege.id">
                                        <tr v-if="privilege.enableStock" :class="{'absent': (!privilege.enableStock)}" class="item">
                                            <td data-label="Фото" class="noAfter">
                                                <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + privilege.img +'.png'" :autoplay="true" :description="privilege.name">-->
                                                    <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + privilege.img + '.png'"-->
                                                         <!--:alt="privilege.name" />-->
                                                <!--</silentbox-single>-->
                                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + privilege.img + '.png'" :autoplay="true" :description="privilege.name">
                                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + privilege.img + '.png'"
                                                         :alt="privilege.name" />
                                                </silentbox-single>
                                            </td>
                                            <td data-label="Наименование товара">{{privilege.name}}</td>
                                            <td data-label="Min заказ" class="noAfter">{{privilege.package}}{{privilege.measure}}</td>
                                            <td data-label="Кол-во" class="noAfter">
                                                <div v-if="privilege.enableStock" class="input-group">
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-left-minus" @click="itemMinus(item.id, privilege.id)">
                                                            <i class="la la-minus"></i>
                                                        </button>
                                                    </span>
                                                    <input v-if="privilege.allowEdit" name="quantity" class="form-control input-number" type="number" min="0" v-model="privilege.count" @input="updateCount(item.id, privilege.id, false)" @change="updateCount(item.id, privilege.id, true)">
                                                    <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="privilege.count">
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-right-plus" @click="itemPlus(item.id, privilege.id)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: privilege.clicked && (privilege.count + privilege.package) > privilege.gdsInStock}">
                                                            <i class="la la-plus"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </td>
                                            <td data-label="Сумма по прайсу" class="sum">
                                                <div v-if="privilege.enableStock">
                                                    <span class="allSum">{{privilege.sum | fixed}} руб.</span>
                                                    <span class="pricePerOne">{{privilege.priceRub | fixed}} руб./{{privilege.measure}}</span>
                                                </div>
                                            </td>
                                            <td data-label="Сумма со скидкой" class="saleSum noAfter">
                                                <div class="totalSale" v-if="privilege.enableStock">
                                                    -<span>{{privilege.priv_sale}}</span>%
                                                </div>
                                                <div v-if="privilege.enableStock">
                                                    <span class="allSaleSum">{{privilege.sale_sum | fixed}} руб.</span>
                                                    <span class="pricePerOne">{{privilege.priceRubSale | fixed}} руб./{{privilege.measure}}</span>
                                                </div>
                                                <!--<img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                                <img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1 && action2.indexOf(privilege.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                                <img v-else-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1 && action3.indexOf(privilege.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                                <img v-else-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                            </td>
                                            <td v-if="privilege.enableStock">
                                                <button v-if="!privilege.selected" class="btn btn-privilege" @click="add(item.id, privilege.id)" type="button"><i class="las la-crown"></i> Добавить</button>
                                                <input v-if="privilege.selected" class="btn btn-secondary" @click="add(item.id, privilege.id)" value="Отменить" type="button" />
                                            </td>
                                            <td v-else>
                                                {{privilege.stockAlt}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr v-if="item.analogsExpanded">
                                <td colspan="7" class="noAfter">
                                    <div class="buyMoreContainer">
                                        <h3>Аналоги</h3>
                                        <table class="table buyMore">
                                            <tbody v-for="analog in item.analogsArray" v-bind:key="analog.id">
                                            <tr v-if="analog.enableStock" :class="{'absent': (!analog.enableStock)}" class="item">
                                                <td data-label="Фото" class="noAfter">
                                                    <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + privilege.img +'.png'" :autoplay="true" :description="privilege.name">-->
                                                    <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + privilege.img + '.png'"-->
                                                    <!--:alt="privilege.name" />-->
                                                    <!--</silentbox-single>-->
                                                    <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + analog.img + '.png'" :autoplay="true" :description="analog.name">
                                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + analog.img + '.png'"
                                                             :alt="analog.name" />
                                                    </silentbox-single>
                                                </td>
                                                <td data-label="Наименование товара">{{analog.name}}</td>
                                                <td data-label="Min заказ" class="noAfter">{{analog.package}}{{analog.measure}}</td>
                                                <td data-label="Кол-во" class="noAfter">
                                                    <div v-if="analog.enableStock" class="input-group">
                                                        <span class="input-group-prepend">
                                                            <button class="btn quantity-left-minus" @click="itemMinus(analog.id, 0)">
                                                                <i class="la la-minus"></i>
                                                            </button>
                                                        </span>
                                                        <input v-if="analog.allowEdit" name="quantity" class="form-control input-number" type="number" min="0" v-model="analog.count" @input="updateCount(analog.id, 0, false)" @change="updateCount(analog.id, 0, true)">
                                                        <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="analog.count">
                                                        <span class="input-group-prepend">
                                                            <button class="btn quantity-right-plus" @click="itemPlus(analog.id, 0)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: analog.clicked && (analog.count + analog.package) > analog.gdsInStock}">
                                                                <i class="la la-plus"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td data-label="Сумма по прайсу" class="sum">
                                                    <div v-if="analog.enableStock">
                                                        <span class="allSum">{{analog.sum | fixed}} руб.</span>
                                                        <span class="pricePerOne">{{analog.priceRub | fixed}} руб./{{analog.measure}}</span>
                                                    </div>
                                                </td>
                                                <td data-label="Сумма со скидкой" class="saleSum noAfter">
                                                    <div class="totalSale" v-if="analog.enableStock">
                                                        -<span>{{analog.real_sale}}</span>%
                                                    </div>
                                                    <div v-if="analog.enableStock">
                                                        <span class="allSaleSum">{{analog.sale_sum | fixed}} руб.</span>
                                                        <span class="pricePerOne">{{analog.priceRubSale | fixed}} руб./{{analog.measure}}</span>
                                                    </div>
                                                    <!--<img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                                    <img v-if="analog.discount_pics_ids.indexOf(analog.id) !== -1 && action2.indexOf(analog.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                                    <img v-else-if="analog.discount_pics_ids.indexOf(analog.id) !== -1 && action3.indexOf(analog.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                                    <img v-else-if="analog.discount_pics_ids.indexOf(analog.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                                </td>
                                                <td v-if="analog.enableStock">
                                                    <button v-if="!analog.selected" class="btn btn-primary" @click="add(analog.id, 0)" type="button">Добавить</button>
                                                    <input v-if="analog.selected" class="btn btn-secondary" @click="add(analog.id, 0)" value="Отменить" type="button" />
                                                </td>
                                                <td v-else>
                                                    {{analog.stockAlt}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 v-else-if="filterData.types.length > 0 || filterData.colors.length > 0 || filterData.prices.length > 0 || filterData.blackouts.length > 0">По выбранным параметрам материалов не найдено. Рекомендуем изменить параметры.</h3>

                    <div class="row justify-content-center">
                        <div class="col-md-5" style="padding: 40px 0;">
                            <a href="/configurator/" class="btn btn-outline-primary btn-lg btn-block">
                                <i class="las la-angle-left"></i> Вернуться
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <nav class="navbar fixed-bottom navbar-expand-lg navbar-light bg-light saleInfo">
                <div class="container collapse navbar-collapse" id="navbarCollapse">
                    <div>
                        <span v-if="set.sale < 35 && set.next_sum > 0" class="navbar-text mr-4">
                            Для получения скидки
                            <span class="red">{{set.next_sale}}%</span>
                            необходимо увеличить заказ на сумму:
                            <span class="red">{{set.next_sum | fixed | separate}}</span> руб.
                        </span>
                        <span v-else-if="set.sale === 35" class="red">У Вас максимальная скидка! </span>
                        <span v-else class="red">
                            Для получения скидки
                            <span class="red">{{set.next_sale}}%</span>
                            необходимо заказать полный комплект
                        </span>

                        <!--<span class="navbar-text">-->
                            <!--<span>Выбрано: </span>-->
                            <!--<span v-bind:class="{green: group.restAmount == 0}">{{group.actualAmount}}</span>-->
                            <!--<span> из </span>-->
                            <!--<span v-bind:class="{red: group.restAmount > 0}">{{group.amountAct}}</span>-->
                            <!--<span> / осталось: </span>-->
                            <!--<span class="left">{{group.restAmount}}</span>-->
                        <!--</span>-->
                    </div>

<!--                    <form class="form-inline" style="margin-left: auto">-->
<!--                        <button class="btn btn-outline-success my-2 my-sm-0 saleButton" type="button" @click="openSale()">Партнерская программа предоставления скидок</button>-->
<!--                    </form>-->

                    <form class="form-inline" style="margin-left: auto">
                        <button class="btn btn-outline-success my-2 my-sm-0 saleButton" type="button" @click="openPartnerProgram()">
                            <span class="big">Партнерская программа предоставления скидок</span>
                            <span class="min" style="display: none;">Партнерская программа</span>
                        </button>
                        <button class="btn btn-primary my-2 my-sm-0 saleButton" style="margin-left: 5px;" type="button" @click="openSale()"><i class="las la-shopping-cart"></i> Состояние</button>
                    </form>
                </div>
            </nav>

            <div v-if="saleVisible" class="popoverContent">
                <table class="table table-borderless" cellspacing="0">
                    <tbody>
                    <tr>
                        <td colspan="2" style="text-align: center; ">
                            <a href="javascript:" class="saleButton" @click="openSale()"><i class="las la-angle-down"></i> Свернуть</a>
                        </td>
                    </tr>

                    <tr v-if="count.basket + count.manual > 0"><td colspan="2" class="text-center" style="font-size: 17px; padding: 0"><i class="las la-shopping-cart" style="font-size: 28px;"></i> <span style="vertical-align: 3px;">Корзина</span></td></tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Сумма заказа без скидок</td>
                        <td>{{crm.fullsum | fixed | separate}} руб.</td>
                    </tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Ваша Экономия</td>
                        <td class="red">{{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.</td>
                    </tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Итоговая сумма заказа с персональными скидками</td>
                        <td class="red">{{crm.saletotalsum | fixed | separate}} руб.</td>
                    </tr>

                    <tr v-if="count.basket + count.manual == 0"><td colspan="2" class="text-center" style="font-size: 20px;">Ваша корзина пуста</td></tr>

                    <tr style="border-top: 1px solid #8c8c8c">
                        <td>Сумма отгрузок за предыдущий период</td>
                        <td>{{crm.user.sum | fixed | separate}} руб.</td>
                    </tr>

                    <!--<tr>-->
                    <!--<td colspan="2" style="text-align: center">-->
                    <!--<a href="javascript:" @click="openPartnerProgram()"><i class="las la-info"></i> Партнерская программа предоставления скидок</a>-->
                    <!--</td>-->
                    <!--</tr>-->
                    </tbody>
                </table>
            </div>

            <modal name="partner-program" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div id="saleRules"></div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="closePartnerProgram()">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="video" :min-width="200"
                   :min-height="200"
                   :scrollable="true"
                   :reset="true"
                   width="600px"
                   height="auto">
                <div style="padding: 20px">
                    <div id="video" class="text-center">
                        <iframe width="560" height="315" :src="activeVideoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('video')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

        </main>
    </div>
</template>

<script>
    import ai_helper from '../js/aihelper/ai_helper';
    import AI_helperItemClass from "../js/aihelper/classes/ai_helperItemClass";

    let series = require("async-series");

    export default {
        name: "ItemsList",
        metaInfo: {
            title: 'Интеллектуальный конфигуратор заказа',
            titleTemplate: '%s - sale.katris'
        },
        props: ['setId', 'groupId'],
        filters: {
            fixed(value) {
                return value.toFixed(2)
            },
            separate(value) {
                let parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            }
        },
        data() {
            return {
                search: '',
                items: [],
                set: '',
                group: '',
                loading: true,
                addedCounter: 0,
                saleVisible: false,
                count: {
                    number: 0,
                    basket: 0,
                    manual: 0
                },
                crm: {
                    user: {
                        sum: 0
                    },
                    fullsum: 0,
                    salesum: 0,
                    saletotalsum: 0,
                    fullsumPreview: 0,
                    salesumPreview: 0,
                    saletotalsumPreview: 0
                },
                // action2: [30005625,30005627,30005628,30005631,30005632,30005633,30005636,30005578,30005042,30004819,30003652,30005049,30005072,30004386,30004375,30005098,30004705,30004702,30004706,30004379,30005051,30004891,30004890,9990,30004818,30004817,30004816,30005035,30005034,30005038,30005039,30005037,30005305,30005304,30004452,30005255,30005257,30005261,30005262,30005315,30005318,30005265,30005266,30005301,30005334,30005330,30005325,30005326,10072,10084,10083,10085,10073,10088,10086,8465,8470,8533,8560,9454,10074,30004118,10096,10097,30005376,30005377,30004049,10094,10102,10101,10104,10105,30005561,10095,10098,10069,10075,30004052,10076,10070,10078,30004754,30004051,30004048],
                // action3: [9823,9839,9830,9834],
                action2: [],
                // action3: [10096, 10097, 30005376, 30005377, 10095, 30005561, 10078, 30005621, 30005045, 30005056, 30004706, 30005189, 30004452, 30005265, 30005334, 30005325, 30005326, 30005187, 30004817],
                action3: [],
                action4: [10484, 10510, 30003924, 30003926, 30003927, 30003931, 30003934, 30003937, 30003938, 30003989, 30003992, 30004055, 30004059, 30004141, 30004157, 30004163, 30004164, 30004170, 30004172, 30004173, 30004176, 30004179, 30004205, 30004232, 30004233, 30004235, 30004276, 30004277, 30004278, 30004469, 30004470, 30004471, 30004472, 30004473, 30004474, 30004515, 30004516, 30004517, 30004518, 30004526, 30004534, 30004563, 30004571, 30004575, 30004576],
                linkContent: 'ЗНАК КАЧЕСТВА<br/><img src="/img/itemListLogo.png" style="width: 80%; display: block; margin: 0 auto;" />',
                jsonKatris: {},
                qualityFlagsArray: [],
                activeThumbID: 0,
                notifyList: [],
                activeVideoLink: '',
                boxAction: [],
                timeout: 5000,
                filterData: {
                    colors: [],
                    prices: [],
                    blackouts: [],
                    types: []
                },
                filtersAvailable: {
                    colors: [],
                    prices: [],
                    blackouts: [],
                    types: []
                },
                filterOpened: true,
                zebraParents: [30005303, 30004424, 30005956, 30004423, 30005953, 30005938, 30005306, 30005259, 30006023, 30005316, 30005263, 30006026, 30005310, 30004425, 30005961, 30006029, 30005945, 30005941, 30005331, 30005967, 30005927, 30005232, 30005328, 30005267, 30005323, 30006032],
                colorsFilterOpened: false
            }
        },
        mounted() {
            window.scrollTo(0, 0);

            window.onscroll = function() {
                stick()
            };

            let navbar = document.getElementById("title");

            let sticky = navbar.offsetTop;

            function stick() {
                if (window.pageYOffset >= sticky && document.body.clientHeight > 1550) {
                    navbar.classList.add("sticky")
                } else {
                    navbar.classList.remove("sticky");
                }
            }
        },
        computed: {
            filteredList() {
                let self = this;
                function compare(a, b) {
                    if (a.name < b.name)
                        if (typeof InstallTrigger !== 'undefined') {
                            return -1;
                        } else {
                            return 1;
                        }
                    if (a.name > b.name)
                        if (typeof InstallTrigger !== 'undefined') {
                            return 1;
                        } else {
                            return -1;
                        }
                    return 0;
                }
                function line(a, b) {
                    // Сортировка тканей Лайн, чтобы сначала шли Лайн, а после Лайн New
                    let compareA = a.name.split(' ');
                    let compareB = b.name.split(' ');

                    if (compareA[0] == 'Лайн' && compareB[0] == 'Лайн') {
                        if (compareA[compareA.length - 1] != 'New' && compareB[compareB.length - 1] == 'New') {
                            return -1;
                        }
                        if (compareA[compareA.length - 1] == 'New' && compareB[compareB.length - 1] != 'New') {
                            return 1;
                        }
                    }
                    return 0;
                }
                function action(a, b) {
                    if (b.discount_pics_ids.indexOf(b.id) == -1)
                        return -1;
                    if (b.discount_pics_ids.indexOf(b.id) !== -1)
                        return 1;
                    return 0;
                }
                return this.items.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase())
                }).sort(compare).sort(line).sort(action).filter(item => {
                    if (self.filterData.prices.length > 0) {
                        if (self.filterData.prices.indexOf(item.priceGroup) != -1) {
                            return item;
                        }
                    } else {
                        return item;
                    }
                }).filter(item => {
                    if (self.filterData.colors.length > 0) {
                        if (self.filterData.colors.indexOf(item.colorGroup) != -1) {
                            return item;
                        }
                    } else {
                        return item;
                    }
                }).filter(item => {
                    if (self.filterData.blackouts.length > 0) {
                        if (self.filterData.blackouts.indexOf(item.blackoutGroup) != -1) {
                            return item;
                        }
                    } else {
                        return item;
                    }
                }).filter(item => {
                    if (self.filterData.types.length == 2 || self.filterData.types.length == 0) {
                        return item;
                    } else {
                        if (self.filterData.types[0] == 1) {
                            if (self.zebraParents.indexOf(item.parent) == -1) {
                                return item;
                            }
                        } else if (self.filterData.types[0] == 2) {
                            if (self.zebraParents.indexOf(item.parent) != -1) {
                                return item;
                            }
                        }
                    }
                })
            }
        },
        created() {
            let self = this;

            let params = {
                url: 'https://sale.katris.ru/proxy/',
                session: this.$session.get('user')
            };

            this.count = this.$countGlobal;

            series([
                function(done) {
                    ai_helper.makePost('katrisService', 'getQualityFlags', {'token': self.$session.get('jwt')}, null, function(response) {
                        if (response.status === 'OK') {
                            self.qualityFlagsArray = response.data;
                            done()
                        }
                    })
                },
                function(done) {
                    ai_helper.makePost('katrisService', 'getKatrisGoods', {}, null, function (respond) {
                        if (respond.status === 'OK') {
                            self.jsonKatris = respond.data;
                            done()
                        }
                    })
                },
                function(done) {
                    ai_helper.makePost('katrisService', 'getNotifications', {'token': self.$session.get('jwt')}, null, function(response) {
                        // console.log(response)
                        if (response.status === 'OK') {
                            self.notifyList = response.data;
                            done()
                        }
                    });
                },
                function(done) {
                    if (self.groupId == 8460) {
                        ai_helper.makePost('katrisService', 'getBoxAction', {'token': self.$session.get('jwt')}, null, function (response) {
                            if (response.status === 'OK') {
                                for (let item in response.data) {
                                    self.boxAction.push(parseInt(response.data[item].goodID))
                                }

                                done()
                            }
                        });
                    } else {
                        done();
                    }
                },
                function() {
                    ai_helper.init(params, function () {
                        ai_helper.restoreComplects();

                        for (let key in ai_helper.complects) {
                            if (ai_helper.complects[key] && ai_helper.complects[key].id == self.setId) {
                                self.set = ai_helper.complects[key];
                            }
                        }

                        for (let key in self.set.groups) {
                            if (self.set.groups[key].id == self.groupId) {
                                self.group = self.set.groups[key];
                            }
                        }

                        let groups_request = [];
                        if (self.set.groups[0]) {
                            for (let key in self.set.groups) {
                                if (Object.prototype.hasOwnProperty.call(self.set.groups, key)) {
                                    groups_request.push({
                                        id: self.set.groups[key].id,
                                        id_good_inet: self.set.groups[key].id_good_inet,
                                        gids: self.set.groups[key].gids
                                    });
                                }
                            }
                        }

                        self.crm.user.sum = ai_helper.user.sum;
                        self.crm.fullsum = ai_helper.fullsum;
                        self.crm.fullsumbasket = ai_helper.fullsumbasket;
                        self.crm.salesum = ai_helper.salesum;
                        self.crm.saletotalsum = ai_helper.saletotalsum;
                        self.crm.saletotalsumbasket = ai_helper.saletotalsumbasket;
                        self.crm.previewsum = ai_helper.previewsum;

                        setTimeout(function () {
                            self.crm.user.sum = ai_helper.user.sum;
                            self.crm.fullsum = ai_helper.fullsum;
                            self.crm.fullsumbasket = ai_helper.fullsumbasket;
                            self.crm.salesum = ai_helper.salesum;
                            self.crm.saletotalsum = ai_helper.saletotalsum;
                            self.crm.saletotalsumbasket = ai_helper.saletotalsumbasket;
                            self.crm.previewsum = ai_helper.previewsum;
                        }, 5000);

                        self.set.get_groups_bubbles(groups_request, function (data) {
                            self.set.initGroupsBubbleData(data);

                            self.group.event();
                            self.group.getActualAmount();
                            self.set.get_basket_sum();

                            let items = [];

                            // console.log(data)

                            // for (let obj in data['9467']) {
                            //     console.log(data['9467'][obj].name)
                            // }

                            // for (let item in self.group.bubbleItems) {
                            //     self.group.bubbleItems[item].sale = self.group.sale;
                            //
                            //     if (!(item in self.group.items)) {
                            //         items.push(new AI_helperItemClass(self.group.bubbleItems[item], ai_helper, false, 'groupAdd'));
                            //     }
                            // }

                            for (let item in data[self.groupId]) {
                                // console.log(parent)

                                data[self.groupId][item].sale = self.group.sale;

                                if (!(item in self.group.items)) {
                                    items.push(new AI_helperItemClass(data[self.groupId][item], ai_helper, false, 'groupAdd'));
                                } else {
                                    self.addedCounter++;
                                }
                            }

                            self.filtersAvailable = {
                                colors: [],
                                prices: [],
                                blackouts: [],
                                types: []
                            }

                            for (let key in items) {
                                let parent = self.jsonKatris.goods[items[key].id].id_parent;
                                items[key].parent = parent;

                                self.filtersAvailable.blackouts.push(items[key].blackoutGroup);
                                self.filtersAvailable.prices.push(items[key].priceGroup);
                                self.filtersAvailable.colors.push(items[key].colorGroup);

                                if (self.zebraParents.indexOf(parent) != -1) {
                                    self.filtersAvailable.types.push(2);
                                } else {
                                    self.filtersAvailable.types.push(1);
                                }

                                items[key].privileges = [];
                                items[key].selected = false;
                                items[key].clicked = false;
                                items[key].clicked2 = false;
                                items[key].privilegesExpanded = false;
                                items[key].analogs = false;
                                items[key].analogsExpanded = false;
                                items[key].analogsArray = [];
                                items[key].count = items[key].package;
                                items[key].sum = items[key].count * items[key].priceRub;
                                items[key].sale_sum = items[key].count * items[key].priceRubSale;
                                items[key].allowEdit = true;
                                items[key].qualityFlag = false;
                                items[key].qualityFlagText = '';
                                items[key].videoLink = '';
                                items[key].notify = false;
                                items[key].notificationID = 0;
                                items[key].box = false;
                                items[key].count1 = items[key].count;
                                items[key].count2 = 800;

                                // if (self.boxAction.indexOf(items[key].id) != -1) {
                                //     items[key].count = items[key].count2;
                                // }

                                if (items[key].stockColor == '#BDF0BD') items[key].stockColor = '#fff';

                                self.items.push(items[key]);

                                // console.log(items[key])
                            }

                            for (let key in self.items) {
                                for (let flag in self.qualityFlagsArray) {
                                    if (self.qualityFlagsArray[flag].goodID == self.items[key].id && self.qualityFlagsArray[flag].active == 1) {
                                        self.items[key].qualityFlag = true;
                                        self.items[key].qualityFlagText = self.qualityFlagsArray[flag].text;
                                        self.items[key].videoLink = self.qualityFlagsArray[flag].videoLink;
                                    } else if (self.qualityFlagsArray[flag].goodID == self.items[key].id) {
                                        self.items[key].qualityFlag = false;
                                        self.items[key].qualityFlagText = '';
                                        self.items[key].videoLink = '';
                                    }
                                }

                                for (let notify in self.notifyList) {
                                    if (self.notifyList[notify].goodID == self.items[key].id && self.notifyList[notify].active == 1 && self.notifyList[notify].type == 1) {
                                        self.items[key].notify = true;
                                        self.items[key].notificationID = self.notifyList[notify].id;
                                    } else if (self.notifyList[notify].goodID == self.items[key].id) {
                                        self.items[key].notify = false;
                                    }
                                }

                                if (!(self.items[key].enableStock || self.items[key].enableStock2 || self.items[key].enableStock3) && !self.items[key].has_priv) {
                                    for (let key2 in self.items) {
                                        if (self.items[key2].colorGroup == self.items[key].colorGroup && (self.items[key2].enableStock || self.items[key2].enableStock2 || self.items[key2].enableStock3)) {
                                            if (self.jsonKatris.folders[self.jsonKatris.goods[self.items[key].id].id_parent].id_parent != 30004423) {
                                                if (self.jsonKatris.folders[self.jsonKatris.goods[self.items[key2].id].id_parent].id_parent != 30004423) {
                                                    self.items[key].analogsArray.push(self.items[key2]);

                                                    if (!self.items[key].analogs) self.items[key].analogs = true;
                                                }
                                            } else {
                                                if (self.jsonKatris.folders[self.jsonKatris.goods[self.items[key2].id].id_parent].id_parent == 30004423) {
                                                    self.items[key].analogsArray.push(self.items[key2]);

                                                    if (!self.items[key].analogs) self.items[key].analogs = true;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (self.items[key].analogs) self.items[key].analogsArray.sort(self.compare);
                            }

                            console.log(self.items)

                            self.updateItems();
                            self.loading = false;

                        });
                    });
                }
            ]);
        },
        methods: {
            compare: function(a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            },
            add: function(id, privilegeId) {
                let self = this;
                let item, privilege, selected = false;
                for (let key in self.items) {
                    if (self.items[key].id == id) {
                        item = key;
                        if (privilegeId == 0) {
                            selected = self.items[key].selected = !self.items[key].selected;
                        } else {
                            for (let privilegeItem in self.items[item].privileges) {
                                if (self.items[item].privileges[privilegeItem].id == privilegeId) {
                                    privilege = self.items[item].privileges[privilegeItem];
                                    selected = self.items[item].privileges[privilegeItem].selected = !self.items[item].privileges[privilegeItem].selected;
                                }
                            }
                        }
                    }
                }

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key].id == self.setId) {
                        ai_helper.complects[key].check1 = false;
                        ai_helper.complects[key].check2 = false;

                        for (let group in ai_helper.complects[key].groups) {
                            if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                if (selected) {
                                    if (privilegeId == 0) {
                                        ai_helper.complects[key].groups[group].items[id] = self.items[item];
                                    } else {
                                        ai_helper.complects[key].groups[group].items[privilegeId] = privilege;
                                    }
                                } else {
                                    if (privilegeId == 0) {
                                        delete ai_helper.complects[key].groups[group].items[id];
                                    } else {
                                        delete ai_helper.complects[key].groups[group].items[privilegeId];
                                    }
                                }
                            }
                        }
                    }
                }
                ai_helper.storeComplects();
                ai_helper.check_complect();

                // console.log(ai_helper);

                self.group.event();
                self.group.getActualAmount();
                self.set.get_basket_sum();

                self.updateItems();

                if (selected) {
                    self.addedCounter++;
                } else {
                    self.addedCounter--;
                }
            },
            expandPrivileges: function(id) {
                let self = this;
                for (let key in self.items) {
                    if (self.items[key].id == id) {
                        if (self.items[key].privileges.length == 0) {
                            ai_helper.makePost('aiHelper', 'get_privilege_bubble', {
                                id: self.items[key].id,
                                color: self.items[key].stockColor
                            }, null, function (respond) {
                                let privileges = [];
                                if (respond.status === 'OK') {
                                    for (let item in respond.data) {
                                        if (respond.data[item].enableStock) {
                                            respond.data[item].count = respond.data[item].package;
                                            respond.data[item].sum = respond.data[item].priceRub * respond.data[item].count;
                                            respond.data[item].sale_sum = respond.data[item].priceRubSale * respond.data[item].count;
                                            let privilege = new AI_helperItemClass(respond.data[item], ai_helper, false, 'groupAdd');
                                            privilege.selected = false;
                                            privilege.clicked = false;

                                            privilege.allowEdit = true;

                                            privileges.push(privilege);
                                        }
                                    }

                                    self.items[key].privileges = privileges;
                                    self.items[key].privilegesExpanded = !self.items[key].privilegesExpanded;
                                } else {
                                    console.error('Error loading privileges');
                                }
                            });
                        } else {
                            self.items[key].privilegesExpanded = !self.items[key].privilegesExpanded;
                        }
                    }
                }
            },
            expandAnalogs: function(id) {
                let self = this;
                for (let key in self.items) {
                    if (self.items[key].id == id) {
                        self.items[key].analogsExpanded = !self.items[key].analogsExpanded;
                    }
                }
            },
            updateItems: function() {
                let self = this;
                // console.log(self.set);

                for (let item in this.items) {
                    this.items[item].setSale(self.set.sale, self.set.wholeSum);

                    for (let item2 in self.items[item].analogsArray) {
                        self.items[item].analogsArray[item2].setSale(self.set.sale, self.set.wholeSum);
                    }
                }
            },
            itemPlus: function(itemId, privilegeId) {
                let self = this;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {
                        this.items[item].box = false;
                        this.items[item].count = this.items[item].count1;

                        if (privilegeId == 0) {
                            if (this.items[item].count + this.items[item].package <= this.items[item].gdsInStock) {
                                this.items[item].count += this.items[item].package;
                                this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                                this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;
                            } else {
                                this.items[item].clicked = true;
                                setTimeout(function () {
                                    self.items[item].clicked = false;
                                }, 2500);
                            }
                            if (this.items[item].selected) {
                                for (let key in ai_helper.complects) {
                                    if (ai_helper.complects[key].id == self.setId) {
                                        for (let group in ai_helper.complects[key].groups) {
                                            if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                    if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                        ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count;
                                                        ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                    }
                                                }
                                                ai_helper.complects[key].groups[group].event();
                                                ai_helper.complects[key].groups[group].getActualAmount();
                                            }
                                        }
                                        ai_helper.complects[key].get_basket_sum();
                                    }
                                }
                                ai_helper.storeComplects();
                            }
                        } else {
                            for (let privilege in this.items[item].privileges) {
                                if (this.items[item].privileges[privilege].id == privilegeId) {
                                    if (this.items[item].privileges[privilege].count + this.items[item].privileges[privilege].package <= this.items[item].privileges[privilege].gdsInStock) {
                                        this.items[item].privileges[privilege].count += this.items[item].privileges[privilege].package;
                                        this.items[item].privileges[privilege].sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRub;
                                        this.items[item].privileges[privilege].sale_sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRubSale;
                                    } else {
                                        this.items[item].privileges[privilege].clicked = true;
                                        setTimeout(function() {
                                            self.items[item].privileges[privilege].clicked = false;
                                        }, 2500);
                                    }
                                    if (self.items[item].privileges[privilege].selected) {
                                        for (let key in ai_helper.complects) {
                                            if (ai_helper.complects[key].id == self.setId) {
                                                for (let group in ai_helper.complects[key].groups) {
                                                    if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                        for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                            if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                                for (let privilege2 in ai_helper.complects[key].groups[group].items[item2].privileges) {
                                                                    if (ai_helper.complects[key].groups[group].items[item2].privileges[privilege2].id == privilegeId) {
                                                                        ai_helper.complects[key].groups[group].items[item2].privileges[privilege2].count = this.items[item].privileges[privilege].count;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        ai_helper.storeComplects();
                                    }
                                }
                            }
                        }

                        this.items[item].count1 = this.items[item].count;
                    }
                }

                self.updateItems();
            },
            itemMinus: function(itemId, privilegeId) {
                let self = this;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {
                        this.items[item].box = false;
                        this.items[item].count = this.items[item].count1;

                        if (privilegeId == 0) {
                            if (this.items[item].count > 0 && (this.items[item].count - this.items[item].package) > 0) {
                                this.items[item].count -= this.items[item].package;
                                this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                                this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;

                                if (this.items[item].selected) {
                                    for (let key in ai_helper.complects) {
                                        if (ai_helper.complects[key].id == self.setId) {
                                            for (let group in ai_helper.complects[key].groups) {
                                                if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                    for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                        if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                            ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count;
                                                            ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                        }
                                                    }
                                                    ai_helper.complects[key].groups[group].event();
                                                    ai_helper.complects[key].groups[group].getActualAmount();
                                                }
                                            }
                                            ai_helper.complects[key].get_basket_sum();
                                        }
                                    }
                                    ai_helper.storeComplects();
                                }
                            } else {
                                this.items[item].clicked2 = true;
                                this.items[item].timeout = 5000;
                                setTimeout(function () {
                                    self.items[item].clicked2 = false;
                                }, self.items[item].timeout);
                            }
                        } else {
                            for (let privilege in this.items[item].privileges) {
                                if (this.items[item].privileges[privilege].id == privilegeId) {
                                    if (this.items[item].privileges[privilege].count > 0 && (this.items[item].privileges[privilege].count - this.items[item].privileges[privilege].package) > 0) {
                                        this.items[item].privileges[privilege].count -= this.items[item].privileges[privilege].package;
                                        this.items[item].privileges[privilege].sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRub;
                                        this.items[item].privileges[privilege].sale_sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRubSale;

                                        if (self.items[item].privileges[privilege].selected) {
                                            for (let key in ai_helper.complects) {
                                                if (ai_helper.complects[key].id == self.setId) {
                                                    for (let group in ai_helper.complects[key].groups) {
                                                        if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                            for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                                if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                                    for (let privilege2 in ai_helper.complects[key].groups[group].items[item2].privileges) {
                                                                        if (ai_helper.complects[key].groups[group].items[item2].privileges[privilege2].id == privilegeId) {
                                                                            ai_helper.complects[key].groups[group].items[item2].privileges[privilege2] = this.items[item].privileges[privilege].count;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            ai_helper.complects[key].groups[group].event();
                                                            ai_helper.complects[key].groups[group].getActualAmount();
                                                        }
                                                    }
                                                    ai_helper.complects[key].get_basket_sum();
                                                }
                                            }
                                            ai_helper.storeComplects();
                                        }
                                    }
                                }
                            }
                        }

                        this.items[item].count1 = this.items[item].count;
                    }
                }
                self.updateItems();
            },
            itemPlusBox: function(itemId, privilegeId) {
                let self = this;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {
                        this.items[item].box = true;
                        this.items[item].count = this.items[item].count2;

                        if (privilegeId == 0) {
                            // let number = nok(this.items[item].package, 800);
                            // this.items[item].numberBox = number;

                            let number = 800;

                            if (this.items[item].count + number <= this.items[item].gdsInStock) {
                                // if (this.items[item].count % 800 != 0) {
                                //     this.items[item].count -= this.items[item].count % 800;
                                // }
                                this.items[item].count += number;
                                this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                                this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;
                            } else {
                                this.items[item].clicked = true;
                                setTimeout(function () {
                                    self.items[item].clicked = false;
                                }, 2500);
                            }
                            if (this.items[item].selected) {
                                for (let key in ai_helper.complects) {
                                    if (ai_helper.complects[key].id == self.setId) {
                                        for (let group in ai_helper.complects[key].groups) {
                                            if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                    if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                        ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count;
                                                        ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                    }
                                                }
                                                ai_helper.complects[key].groups[group].event();
                                                ai_helper.complects[key].groups[group].getActualAmount();
                                            }
                                        }
                                        ai_helper.complects[key].get_basket_sum();
                                    }
                                }
                                ai_helper.storeComplects();
                            }
                        }

                        this.items[item].count2 = this.items[item].count;
                    }


                }
                self.updateItems();
            },
            itemMinusBox: function(itemId, privilegeId) {
                let self = this;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {
                        this.items[item].box = true;
                        this.items[item].count = this.items[item].count2;

                        if (privilegeId == 0) {
                            // let number = nok(this.items[item].package, 800);
                            // this.items[item].numberBox = number;

                            let number = 800;

                            if (this.items[item].count > 0 && (this.items[item].count - number) > 0) {
                                this.items[item].count -= number;
                                this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                                this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;

                                if (this.items[item].selected) {
                                    for (let key in ai_helper.complects) {
                                        if (ai_helper.complects[key].id == self.setId) {
                                            for (let group in ai_helper.complects[key].groups) {
                                                if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                    for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                        if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                            ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count;
                                                            ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                        }
                                                    }
                                                    ai_helper.complects[key].groups[group].event();
                                                    ai_helper.complects[key].groups[group].getActualAmount();
                                                }
                                            }
                                            ai_helper.complects[key].get_basket_sum();
                                        }
                                    }
                                    ai_helper.storeComplects();
                                }
                            }
                        }

                        this.items[item].count2 = this.items[item].count;
                    }
                }
                self.updateItems();
            },
            updateCount: function(itemId, privilegeId, fix) {
                let self = this;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {

                        if (this.boxAction.indexOf(itemId) != -1) {
                            this.items[item].box = false;
                            this.items[item].count = this.items[item].count1;
                        }

                        if (privilegeId == 0) {
                            if (this.items[item].count > this.items[item].gdsInStock && fix) {
                                this.items[item].count = this.items[item].gdsInStock;

                                this.items[item].clicked = true;
                                setTimeout(function() {
                                    self.items[item].clicked = false;
                                }, 2500);
                            } else if (this.items[item].count < this.items[item].package && fix) {
                                this.items[item].count = this.items[item].package;
                                this.items[item].clicked2 = true;
                                this.items[item].timeout = 5000;
                                setTimeout(function() {
                                    self.items[item].clicked2 = false;
                                }, self.items[item].timeout);
                            }

                            if (!(self.set.id_good == '20000131' && self.group.id == '8460' && [8696, 8693, 8694].indexOf(self.items[item].id) == -1)) {
                                if (fix) {
                                    // console.log(item.count, Math.floor(item.count / item.package), item.package)
                                    self.items[item].count = Math.floor(self.items[item].count / self.items[item].package) * self.items[item].package;
                                }
                            }

                            this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                            this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;

                            if (this.items[item].selected) {
                                for (let key in ai_helper.complects) {
                                    if (ai_helper.complects[key].id == self.setId) {
                                        for (let group in ai_helper.complects[key].groups) {
                                            if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                    if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                        ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count == '' ? 0 : this.items[item].count;
                                                        ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                    }
                                                }
                                                ai_helper.complects[key].groups[group].event();
                                                ai_helper.complects[key].groups[group].getActualAmount();
                                            }
                                        }
                                        ai_helper.complects[key].get_basket_sum();
                                    }
                                }
                                ai_helper.storeComplects();
                            }
                        } else {
                            for (let privilege in this.items[item].privileges) {
                                if (this.items[item].privileges[privilege].id == privilegeId) {
                                    if (this.items[item].privileges[privilege].count > this.items[item].privileges[privilege].gdsInStock && fix) {
                                        this.items[item].privileges[privilege].count = this.items[item].privileges[privilege].gdsInStock;

                                        this.items[item].privileges[privilege].clicked = true;
                                        setTimeout(function() {
                                            self.items[item].privileges[privilege].clicked = false;
                                        }, 2500);
                                    } else if (this.items[item].privileges[privilege].count < this.items[item].privileges[privilege].package && fix) {
                                        this.items[item].privileges[privilege].count = this.items[item].privileges[privilege].package;
                                    }

                                    if (this.items[item].privileges[privilege].count == '') {
                                        this.items[item].privileges[privilege].count = 0;
                                    }

                                    if (!(self.set.id_good == '20000131' && self.group.id == '8460' && [8696, 8693, 8694].indexOf(this.items[item].privileges[privilege].id) == -1)) {
                                        if (fix) {
                                            // console.log(item.count, Math.floor(item.count / item.package), item.package)
                                            this.items[item].privileges[privilege].count = Math.floor(this.items[item].privileges[privilege].count / this.items[item].privileges[privilege].package) * this.items[item].privileges[privilege].package;
                                        }
                                    }

                                    this.items[item].privileges[privilege].sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRub;
                                    this.items[item].privileges[privilege].sale_sum = this.items[item].privileges[privilege].count * this.items[item].privileges[privilege].priceRubSale;

                                    if (self.items[item].privileges[privilege].selected) {
                                        for (let key in ai_helper.complects) {
                                            if (ai_helper.complects[key].id == self.setId) {
                                                for (let group in ai_helper.complects[key].groups) {
                                                    if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                        for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                            if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                                for (let privilege2 in ai_helper.complects[key].groups[group].items[item2].privileges) {
                                                                    if (ai_helper.complects[key].groups[group].items[item2].privileges[privilege2].id == privilegeId) {
                                                                        ai_helper.complects[key].groups[group].items[item2].privileges[privilege2] = this.items[item].privileges[privilege].count == '' ? 0 : this.items[item].privileges[privilege].count;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        ai_helper.storeComplects();
                                    }
                                }
                            }
                        }
                        if (this.boxAction.indexOf(itemId) != -1) this.items[item].count1 = this.items[item].count;
                    }
                }
                ai_helper.storeComplects();
                self.updateItems();
            },
            updateCountBox: function(itemId, privilegeId, fix) {
                let self = this;
                let number = 800;
                for (let item in this.items) {
                    if (this.items[item].id == itemId) {
                        this.items[item].box = true;
                        this.items[item].count = this.items[item].count2;
                        if (privilegeId == 0) {
                            if (this.items[item].count > this.items[item].gdsInStock && fix) {
                                this.items[item].count = this.items[item].gdsInStock;

                                this.items[item].clicked = true;
                                setTimeout(function() {
                                    self.items[item].clicked = false;
                                }, 2500);
                            } else if (this.items[item].count < number && fix) {
                                this.items[item].count = number;
                            }

                            if (!(self.set.id_good == '20000131' && self.group.id == '8460' && [8696, 8693, 8694].indexOf(self.items[item].id) == -1)) {
                                if (fix) {
                                    // console.log(item.count, Math.floor(item.count / item.package), item.package)
                                    self.items[item].count = Math.floor(self.items[item].count / number) * number;
                                }
                            }

                            this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                            this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;

                            if (this.items[item].selected) {
                                for (let key in ai_helper.complects) {
                                    if (ai_helper.complects[key].id == self.setId) {
                                        for (let group in ai_helper.complects[key].groups) {
                                            if (ai_helper.complects[key].groups[group].id == self.groupId) {
                                                for (let item2 in ai_helper.complects[key].groups[group].items) {
                                                    if (ai_helper.complects[key].groups[group].items[item2].id == itemId) {
                                                        ai_helper.complects[key].groups[group].items[item2].count = this.items[item].count == '' ? 0 : this.items[item].count;
                                                        ai_helper.complects[key].groups[group].items[item2].setDomValues();
                                                    }
                                                }
                                                ai_helper.complects[key].groups[group].event();
                                                ai_helper.complects[key].groups[group].getActualAmount();
                                            }
                                        }
                                        ai_helper.complects[key].get_basket_sum();
                                    }
                                }
                                ai_helper.storeComplects();
                            }
                        }
                        this.items[item].count2 = this.items[item].count;
                    }
                }
                ai_helper.storeComplects();
                self.updateItems();
            },
            openSale: function() {
                this.saleVisible = !this.saleVisible;
            },
            openPartnerProgram: function() {
                ai_helper.makePost('aiHelper', 'sales', {}, null,function(respond) {
                    if (respond.status === 'OK') {
                        document.getElementById('saleRules').innerHTML = respond.data;

                        document.querySelector('#saleRules table').classList.add("table");
                    }
                });

                this.$modal.show('partner-program')
            },
            closePartnerProgram: function() {
                this.$modal.hide('partner-program')
            },
            setActiveThumb: function(item) {
                let self = this;

                if (self.activeThumbID != item.id) {
                    self.activeThumbID = item.id
                } else {
                    self.activeThumbID = 0;
                }
            },
            closeFlag: function() {
                this.activeThumbID = 0;
            },
            notifyMe: function(item) {
                let self = this;
                ai_helper.makePost('katrisService', 'createNotification', {'token': this.$session.get('jwt'), 'goodID': item.id, 'type': 1}, null, function(respond) {
                    if (respond.status === 'OK') {
                        item.notify = true;
                        item.notificationID = respond.data.ID;

                        self.$notificationsGlobal.waitListLength += 1;
                        if (self.$notificationsGlobal.emptyNotices) self.$notificationsGlobal.emptyNotices = false;
                    }
                });
            },
            disableNotifications: function(item) {
                let self = this;
                ai_helper.makePost('katrisService', 'disableNotification', {'token': this.$session.get('jwt'), 'notificationID': item.notificationID}, null, function(respond) {
                    if (respond.status === 'OK') {
                        item.notify = false;

                        self.$notificationsGlobal.waitListLength -= 1;
                        if (self.$notificationsGlobal.waitListLength == 0) self.$notificationsGlobal.emptyNotices = true;
                    }
                });
            },
            openVideo: function(link) {
                this.activeVideoLink = link.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
                this.$modal.show('video')
            },
            changeInput: function(item, type) {
                if (type == 1) {
                    item.box = false;
                    item.count = item.count1;
                } else {
                    item.box = true;
                    item.count = item.count2;
                }
                item.setDomValues();
            },
            toggleFilterData: function(type, name) {
                if (this.filterData[type].indexOf(name) == -1) {
                    this.filterData[type].push(name)
                    if (type == 'types' && name == 2) {
                        let pushBlackout = false;
                        if (this.filterData.blackouts.indexOf(5) != -1) {
                            pushBlackout = true
                        }
                        this.filterData.blackouts = [];
                        if (pushBlackout) {
                            this.filterData.blackouts.push(5)
                        }
                    }
                } else {
                    this.filterData[type].splice(this.filterData[type].indexOf(name), 1)
                }
                this.saveFilterData()
            },
            saveFilterData: function() {
                let self = this;
                if (self.search != '' || self.filterData.blackouts.length > 0 || self.filterData.types.length > 0 || self.filterData.colors.length > 0 || self.filterData.prices.length > 0) {
                    ai_helper.makePost('katrisService', 'saveFilterData', {'token': this.$session.get('jwt'), 'filterData': JSON.stringify(self.filterData), 'searchField': self.search, 'group': self.groupId}, null, function(respond) {
                        console.log(respond.data)
                    });
                }
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 630px) {
        h3 .btn {
            margin: 0;
        }
    }
    .green {
        color: #28a745;
    }

    .itemsList thead {
        font-size: 17px;
        font-weight: 600;
        text-align: center;
    }

    .itemsList thead tr {
        padding: 10px 0;
        padding-bottom: 20px;
    }

    .itemsList thead tr td {
        padding: 27px 0;
        padding-top: 0px;
        padding-bottom: 30px;
        position: relative;
    }

    .itemsList td {
        position: relative;
    }

    .itemsList td:after {
        content: '';
        height: 30px;
        width: 1px;
        background: #adadad;
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);
    }
    .itemsList td:nth-last-of-type(1):after {
        background: #fff;
    }
    .itemsList thead td i {
        position: absolute;
        bottom: 5px;
        left: calc(50% - 8px);
    }

    .itemsList td.noAfter:after {
        background: transparent;
    }

    .loader {
        text-align: center;
        padding: 50px 0;
    }
    .loader p {
        font-weight: bold;
        margin-top: 10px;
    }

    #navbarCollapse {
        font-size: 14px;
    }

    .saleButton {
        font-size: 15px;
    }

    .thumb {
        position: absolute;
        right: 2px;
        top: 0px;
        font-size: 24px;
        cursor: pointer;
        color: #006ce0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        resize: vertical;
    }

    .nameSpan {
        width: 90%;
        display: inline-block;
    }

    .buyMoreContainer {
        /*background-color: #27a0f9;*/
        background-color: #007bff;
        padding: 0 10px;
        padding-bottom: 10px;
        border-radius: 10px;
        margin-top: 20px;
    }

    .buyMoreContainer h3 {
        color: #fff;
        font-weight: 400 !important;
        margin-bottom: 0;
    }

    .buyMore {
        /*background-color: #f0f8ffa3 !important;*/
        background-color: #fff !important;
        /*border-bottom: 1px solid #dee2e6;*/
        border-radius: 10px;
    }

    .buyMore tr:first-of-type td {
        border-top: none;
    }

    .btn-outline-primary {
        background: white;
    }
    .btn-outline-primary:hover {
        background: #007bff;
    }

    .boxAction .input-group {
        width: 95%;
        /*display: inline-block;*/
        min-width: 0;
    }

    .boxAction .btn {
        padding: 0 0.25rem
    }

    .boxAction .input-group-prepend {
        /*display: inline-block;*/
    }

    .boxAction input {
        /*display: inline-block;*/
    }

    .boxAction .form-control {
        padding: 0.25rem;
        font-size: 13px;
    }

    .boxAction .form-control:focus {
        box-shadow: none;
    }

    .countField {
        display: inline-block;
        position: relative;
    }

    .boxAction .quantity-right-plus {
        border-bottom-left-radius: unset !important;
        border-top-left-radius: unset !important;
    }

    .boxAction .countField > span {
        text-align: center;
        display: block;
        font-size: 12px;
        font-weight: bold;
    }

    .boxAction .boxSale {
        background-color: red;
        color: white;
        display: inline-block;
        font-size: 10px;
        font-weight: bold;
        border-radius: 50%;
        padding: 5px 2px;
        position: absolute;
        z-index: 100;
        right: 0;
        top: 15px;
    }

    .boxAction .notSelected > span {
        color: grey;
    }

    .boxAction .notSelected button, .boxAction .notSelected input {
        background-color: #b3b3b3;
    }

    .boxAction .notSelected .boxSale {
        background-color: #868686;
    }

    .boxAction > span {
        display: block;
        width: 100%;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        padding: 5px 0;
    }
    .filterButton {
        display: inline-block;
        color: #000;
        font-size: 15px;
        padding: 7px 0;
    }

    .filter-checkboxes .fieldset-checkbox > div {
        position: relative;
        display: inline-block;
        height: 20px;
        margin-right: 10px;
        margin-bottom: 7px;
    }
    .filter-checkboxes .fieldset-checkbox > div input {
        margin: 0;
    }
    .fieldset-checkbox__square input {
        position: absolute;
        z-index: -1;
        width: 20px !important;
        height: 20px !important;
        opacity: 0;
    }
    .fieldset-checkbox__square input + label {
        position: relative;
        padding: 0px 0 0 16px;
        cursor: pointer;
        font-size: 14px;
    }
    .filter-checkboxes .fieldset-checkbox > div input.red + label:before {
        background: #f50000;
    }
    .filter-checkboxes .fieldset-checkbox > div input.orange + label:before {
        background: #f99200;
    }
    .filter-checkboxes .fieldset-checkbox > div input.yellow + label:before {
        background: #ff0;
    }
    .filter-checkboxes .fieldset-checkbox > div input.green + label:before {
        background: #1a6f00;
    }
    .filter-checkboxes .fieldset-checkbox > div input.blue + label:before {
        background: #00f;
    }
    .filter-checkboxes .fieldset-checkbox > div input.purple + label:before {
        background: #6a2275;
    }
    .filter-checkboxes .fieldset-checkbox > div input.black + label:before {
        background: #000;
    }
    .filter-checkboxes .fieldset-checkbox > div input.white + label:before {
        background: #fff;
    }
    .filter-checkboxes .fieldset-checkbox > div input.beige + label:before {
        background: #f2f2d2;
    }
    .filter-checkboxes .fieldset-checkbox > div input.gray + label:before {
        background: #6c6c6c;
    }
    .filter-checkboxes .fieldset-checkbox > div input.brown + label:before {
        background: #623500;
    }
    .filter-checkboxes .fieldset-checkbox > div input.light_gray + label:before {
        background: #fff;
    }
    .filter-checkboxes .fieldset-checkbox > div input + label:before {
        border: 1px solid #aaa;
    }
    .fieldset-checkbox__square input + label:before {
        position: absolute;
        top: 4px;
        left: 0;
        width: 13px;
        height: 13px;
        content: '';
        -webkit-border-radius: 2px;
        border-radius: 2px;
    }
    .fieldset-checkbox__square input + label:after {
        position: absolute;
        top: 1px;
        left: -3px;
        width: 19px;
        height: 19px;
        content: '';
        -webkit-transition: .2s;
        transition: .2s;
        opacity: 0;
        border: 2px solid #007bff;
        -webkit-border-radius: 2px;
        border-radius: 4px;
    }
    .filter-checkboxes .filter-title {
        margin: 0px;
        font-weight: bold;
    }
    .fieldset-checkbox__square input:checked + label:after {
        opacity: 1;
    }

    .filter {
        border: 1px solid #dceafd;
        margin: 10px 0;
        border-radius: 15px;
        background-color: #eff6ff;
        padding-top: 5px;
    }
    .filter .button {
        border: 1px solid #ced4da;
        color: #495057;
        height: 34px;
        overflow: hidden;
        background-color: white;
        padding: 7px 9px;
        font-size: 14px;
    }
    .filter .button::after {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.5em solid;
        border-right: 0.2em solid transparent;
        border-bottom: 0;
        border-left: 0.2em solid transparent;
        position: absolute;
        right: 25px;
        top: 38px;
        color: #495057;
    }
    .colorsFilter {
        position: absolute;
        background-color: white;
        z-index: 200;
        border: 1px solid #ced4da;
        box-shadow: 2px 3px 6px 0px #b9b9b9;
        padding: 5px 15px;
    }
    .colorsFilter .fieldset-checkbox > div {
        display: block !important;
    }
    .overlay {
        z-index: 9;
        display: block;
        height: 100vh;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
    }
</style>
